<template>
  <base-content>
    <template v-slot:top>
      <base-banner>Investment Knowledge &amp; Experience</base-banner>
      <appropriateness-steps :step="1" />
    </template>
    <div v-if="loaded">
      <form @submit.prevent="submit">
        <p>
          <span class="q"></span> What is your overall understanding of general financial and economic affairs?
        </p>
        <div class="text-center">
          <button-options name="knowledgeRate"
            :options="options.knowledgeRate"
            v-model="payload.knowledgeRate" />
        </div>
        <p class="mt-4">
          <span class="q"></span> Do you work, or have you worked, in the financial sector for at least one year
          in a professional position or do you consider that you in the position to fully
          understand the nature and risks associated with any investments offered on the website?
        </p>
        <div class="text-center">
          <button-options name="minOneYearExperience"
            :options="options.minOneYearExperience"
            v-model="payload.minOneYearExperience" />
        </div>
        <h6 class="font-weight-bold my-4 pt-4 text-center">
          Have you ever invested in any of the following products previously? Please select all relevant options.
        </h6>
        <base-card v-for="(section, key) in sections" :key="key" :handler="`collapse-${key}`" :closed="!payload.experience[key].hasExperience" collapsible hide-caret>
          <template v-slot:header>
            <base-card-heading>{{ section }}</base-card-heading>
            <button-option
              v-model="payload.experience[key].hasExperience"
              :collapse="`#collapse-${key}`"
              :controls="`collapse-${key}`" />
          </template>
          <div class="row align-items-center">
            <div class="col-sm-8">
              <div class="d-flex">
                <span class="q mt-n3 mr-2"></span>
                <label :for="`experience.${key}.howOften`">
                  How often do you invest in this type of product?
                </label>
              </div>
            </div>
            <div class="col-sm-4 mb-3">
              <base-field>
                <base-select
                  v-model="payload.experience[key].howOften"
                  :id="`experience.${key}.howOften`"
                  placeholder="how often"
                  source="experienceHowOften" />
              </base-field>
            </div>
            <div class="col-sm-8">
              <div class="d-flex">
                <span class="q mt-n3 mr-2"></span>
                <label :for="`experience.${key}.howMuch`">
                  How much do you typically invest in this product type on each investment?
                </label>
              </div>
            </div>
            <div class="col-sm-4 mb-3">
              <base-field>
                <base-select
                  v-model="payload.experience[key].howMuch"
                  :id="`experience.${key}.howOften`"
                  placeholder="how much"
                  source="experienceHowMuch" />
              </base-field>
            </div>
            <div class="col-sm-8">
              <div class="d-flex">
                <span class="q mt-n3 mr-2"></span>
                <label :for="`experience.${key}.howLong`">
                  How long have you been investing in this type of product?
                </label>
              </div>
            </div>
            <div class="col-sm-4">
              <base-field>
                <base-select
                  v-model="payload.experience[key].howLong"
                  :id="`experience.${key}.howLong`"
                  placeholder="how long"
                  source="experienceHowLong" />
              </base-field>
            </div>
          </div>
        </base-card>
        <div class="row">
          <div class="col-12 col-sm-6">
            <base-button exact :to="{ name: 'dashboard' }">Come back later</base-button>
          </div>
          <div class="col-12 col-sm-6 text-right">
            <base-button icon-right="arrow-right" primary submit :loading="saving">
              Next section
            </base-button>
          </div>
        </div>
      </form>
    </div>
    <div v-else>
      <base-loader/>
    </div>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import AppropriatenessSteps from '@/components/AppropriatenessSteps.vue'
import ButtonOption from '@/components/ButtonOption.vue'
import ButtonOptions from '@/components/ButtonOptions.vue'

export default {
  components: {
    AppropriatenessSteps,
    ButtonOption,
    ButtonOptions
  },

  data: () => ({
    loaded: false,
    options: {
      knowledgeRate: {
        None: 'None',
        Limited: 'Limited',
        Good: 'Good',
        Extensive: 'Extensive'
      },
      minOneYearExperience: {
        false: 'No',
        true: 'Yes'
      }
    },
    payload: {},
    saving: false,
    sections: {
      derivatives: 'Derivatives (CFDs, Spreadbetting, FX, Warrants, Futures Options)',
      listedShares: 'Listed shares or other securities listed on a public market or stock exchange',
      privateShares: 'Private shares or other securities offered by private companies',
      collectiveInvestments: 'Collective investments including funds, unit trusts, ETFs',
      peer2Peer: 'Peer-2-peer or other similar alternative investments',
      giltsBonds: 'Gilts, bonds or other interest bearing or similar instruments'
    }
  }),

  mounted () {
    this.payload = this.$_.cloneDeep(this.$auth.user.appropriateness)
    this.loaded = true
  },

  computed: {
    ...mapState({
      appropriateness: store => store.core.userAppropriateness.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/user-appropriateness/update', this.payload)

      this.$store.commit('core/auth/appropriateness', this.appropriateness)

      this.$router.push({ name: 'appropriateness.knowledge' })
    }
  }
}
</script>
